import { store } from '@whelk/store';
import { setShowLoginModal } from '@whelk/store/slices/userSlice';
import { isMiniProgram } from '@whelk/utils';
import { nativeBridge } from '@whelk/utils/src/bridge/callNativeBridge';

import { trackCustomEvent } from './track';
import { isNative } from '@whelk/const/src/env';
export const checkLogin = () => {
  if (!store.getState().user.isLogin) {
    return false;
  }
  return true;
};

// native 打开login modal
export const openNaitveLoginModal = () => {
  nativeBridge.callNative({ methodName: 'launchLogin', params: { loginFrom: 'chat_page' } });
};

// "登录点击：login_click、历史记录点击：chat_history_click、地域限制：area_limit、消息限制：chat_limit"
export const openLoginModal = (
  origin?: 'login_click' | 'chat_history_click' | 'area_limit' | 'chat_limit',
) => {
  if (!checkLogin() && isMiniProgram) {
    if (!(window as any).wx) return;
    (window as any).wx.miniProgram.navigateTo({ url: '/pages/login/index' });
    return;
  }
  if (isNative) {
    openNaitveLoginModal();
    return;
  }
  store.dispatch(setShowLoginModal(true));
  if (origin) {
    trackCustomEvent({
      id: 'login_popup_view',
      login_enter_scene: origin,
      page: 'login_popup_page',
    });
  }
};
